export class arwardCriteria {
    id: number;
    individual: number;
    team: number;
    numberOfPoints: number;
}